import i18n from './i18n';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './reset.css';
import './App.css';
import logo from './images/logo.png';
import langIcon from './images/lang_ico.png';
import scrollDownIcon from './images/scroll_down_arrow.png';
import aboutSecImg01 from './images/sec_about_img01.png';
import aboutSecImg02 from './images/sec_about_img02.png';
import Section01 from './components/Section01';
import Section02 from './components/Section02';
import toTopIcon from './images/back_to_top.png';
import footerLogo from './images/f_logo.png';

function App() {

    const { t } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    const goToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }

    const secAboutRef = useRef();
    const sec01Ref = useRef(null);
    const sec02Ref = useRef(null);

    const goToAbout = () => {
        window.scrollTo({
            top: secAboutRef.current.offsetTop,
            behavior: 'smooth',
        })
    }

    const goToSec01 = () => {
        window.scrollTo({
            top: sec01Ref.current.offsetTop,
            behavior: 'smooth',
        })
    }

    const goToSec02 = () => {
        window.scrollTo({
            top: sec02Ref.current.offsetTop,
            behavior: 'smooth',
        })
    }

    const [isScrolled, setIsScrolled] = useState(false);
    useEffect(() => {

        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);

        return () => window.removeEventListener('scroll', handleScroll);

    }, []);

    return (
        <div className="App">
            <header className={`${isScrolled ? 'scrolled' : ''}`}>
                <h1>
                    <div onClick={() => { goToTop(); }}>
                        <img src={logo} alt='푸푸트레이드' />
                    </div>
                </h1>
                <ul>
                    <li onClick={() => { goToAbout(); }}>ABOUT US</li>
                    <li onClick={() => { goToSec01(); }}>PRODUCTS</li>
                    <li onClick={() => { goToSec02(); }}>PARTNERS</li>
                </ul>
                <div className='lang_box'>
                    <div className='ico_box'>
                        <img src={langIcon} alt='언어변경' />
                    </div>
                    <div className='txt_box'>
                        <button onClick={() => changeLanguage('ko')}>KO</button>
                        <span>/</span>
                        <button onClick={() => changeLanguage('en')}>EN</button>
                    </div>

                </div>
            </header>
            <div className='main_about_wrapper'>
                <div className='main_vsual'>
                    <div className='txt_box'>
                        <h2>
                            EXPORTING TRUST.<br />
                            OWN THE VALUE.
                        </h2>
                    </div>
                    <div className="scroll_box">
                        <div className="scroll">
                            <svg viewBox="0 0 300 300" className="rotating-text">
                                <defs>
                                    <path
                                        id="circlePath"
                                        d="M150,150 m-100,0 a100,100 0 1,1 200,0 a100,100 0 1,1 -200,0"
                                    />
                                </defs>
                                <text fontSize="34" fill="#fff">
                                    <textPath href="#circlePath" startOffset="0%">
                                        SCROLL SCROLL SCROLL SCROLL
                                    </textPath>
                                </text>
                            </svg>

                            <div className="scroll_img">
                                <img src={scrollDownIcon} alt="스크롤" />
                            </div>
                        </div>
                    </div>
                </div>
                <section className='sec about_sec' ref={secAboutRef}>
                    <div className='sec_title'>
                        <h3>
                            {t('Connecting the E-cigarette Industry')}<br />
                            {t('PUFFU TRADE')}
                        </h3>
                        <p>
                            {t('PUPUTRADE is a trading agency that covers the entire e-cigarette industry,')} <br className='m_br' />
                            {t('specializing in the export of synthetic nicotine and the import of devices.')}
                        </p>
                    </div>
                    <div className='sec_img'>
                        <div className='img_box_wrapper'>
                            <div className='img_box img_box_01'>
                                <img src={aboutSecImg01} alt='전자담배 산업을 연결하는 푸푸트레이드' />
                            </div>
                            <div className='img_box img_box_02'>
                                <img src={aboutSecImg02} alt='전자담배 산업을 연결하는 푸푸트레이드' />
                            </div>
                        </div>

                        <div className="rolling_box">
                            <div className="rolling">
                                <svg viewBox="0 0 300 300" className="rotating-text">
                                    <defs>
                                        <path
                                            id="rollingPath"
                                            d="M150,150 m-100,0 a100,100 0 1,1 200,0 a100,100 0 1,1 -200,0"
                                        />
                                    </defs>
                                    <text fontSize="28" fill="#fff">
                                        <textPath href="#rollingPath" startOffset="0%">
                                            PUFFU TRADE PUFFU TRADE PUFFU TRADE
                                        </textPath>
                                    </text>
                                </svg>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Section01 sec01Ref={sec01Ref} />
            <Section02 sec02Ref={sec02Ref} />

            <footer>
                <div className="top_box">
                    <div className="scroll" onClick={() => { goToTop(); }}>
                        <svg viewBox="0 0 300 300" className="rotating-text">
                            <defs>
                                <path
                                    id="circlePath"
                                    d="M150,150 m-100,0 a100,100 0 1,1 200,0 a100,100 0 1,1 -200,0"
                                />
                            </defs>
                            <text fontSize="28" fill="#fff">
                                <textPath href="#circlePath" startOffset="0%">
                                    BACK TO TOP BACK TO TOP BACK TO TOP
                                </textPath>
                            </text>
                        </svg>
                        <div className="scroll_img">
                            <img src={toTopIcon} alt="스크롤" />
                        </div>
                    </div>
                </div>
                <div className='txt_box'>
                    <p>{t('Together, we shape the future of the e-cigarette industry.')}</p>
                    <div className='img_box'>
                        <img src={footerLogo} alt='푸푸트레이드' />
                    </div>
                </div>
                <div className='f_info'>
                    <div className='corp_info'>
                        <span>
                            <strong>{t('ceo')}</strong>
                            {t('Wang Sohee')}
                        </span>
                        <span>
                            <strong>{t('address')}</strong>
                            {t('5F, 68, Gwanno-jungno 95beon-gil, Seo-gu, Daejeon, Republic of Korea')}
                        </span>
                    </div>
                    <div className='copyright'>
                        <span>
                            © PUFFU TRADE ALL RIGHTS RESERVED.
                        </span>
                    </div>
                </div>
            </footer>
        </div>
    );
}

export default App;
